export const HOME_INSURANCE_STEPS = {
    LANDING: 'step-0-1',
    OBJECT_SUMMARY_READ_ONLY: 'step-1-1',
    OBJECT_SUMMARY_EDITABLE: 'step-1-2',
    CHOOSE_INSURANCE: 'step-1-3',
    INSURANCE_BEGIN_DATE: 'step-1-4',
    ADDITIONAL_RISKS: 'step-1-5',
    CUSTOMER_LOGIN: 'step-1-6',
    POLICYHOLDER_INFORMATION: 'step-1-7',
    SUMMARY: 'step-1-8',
    PAYMENT: {
        OPTIONS: 'step-2-1',
        METHOD_TYPE: 'step-2-2',
        METHOD: 'step-2-3',
    },
};
